import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import MemberDetail from './pages/MemberDetail';
import Chppy from './components/Bot/Chppy';
import './styles/globals.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main className="page-with-fixed-header">
          {/* main routes render here */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/member/:id" element={<MemberDetail />} />
          </Routes>
        </main>
        <Footer />
        <Chppy />
      </div>
    </Router>
  );
}

export default App;